// routes/generator.stitching.$mode.tsx
import { ALLOWED_IMAGE_STITCHING_MODES } from 'src/components/GenerationTask/MultiColumnGenerationForm/ImageStitching/constants'
import { getI18n } from 'src/i18n/i18n.middleware'
import { createRedirect } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.stitching.$mode'

const getClientModule = () =>
  import('src/clientRoutes/generator.stitching.$mode')

export const handle = {
  name: 'generator/stitching/:mode',
  track: ({ params }: { params: { mode?: string } }) => ({
    scene: 'image-stitching',
    section: params.mode,
  }),
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export async function clientLoader({
  request,
  params,
  serverLoader,
}: Route.ClientLoaderArgs) {
  const allowedModes = ALLOWED_IMAGE_STITCHING_MODES as readonly string[]
  if (params.mode && !allowedModes.includes(params.mode)) {
    throw createRedirect(request, '/generator/stitching/kiss')
  }
  return serverLoader?.()
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
